module.exports = __webpack_public_path__ + "img/loudspeaker-icon.5171fa19.svg";